import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { ListResponseWithPagination } from 'services/api/types';
import type { EducationClass, EducationClassListRequest } from './types';

export const getEducationClassList = (
  params: EducationClassListRequest = {},
): Promise<ListResponseWithPagination<EducationClass>> => {
  return appApi
    .get('/educational-classes', {
      params,
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить классы' });
      throw error;
    });
};
